import * as ActionTypes from '../../actions/allActions'
import { bookingNormalizer, bookingActivityNormalizer } from '../../normalizers/Normalizers'

const bookingInit = { currentMessage: "" }
const booking = (state = bookingInit, action) => {
	switch(action.type){
		case ActionTypes.FETCHBOOKING_SUCCESS:
			return { ...state, ...bookingNormalizer(action.data.data) }
		case ActionTypes.BOOKINGDETAILS_DATACHANGE:
			return { ...state, ...action.changes }
		case ActionTypes.SUBMITBOOKINGMESSAGE_SUCCESS:
			return { ...state, currentMessage: "", activities: [ bookingActivityNormalizer(action.data.activity), ...state.activities ]}
		case ActionTypes.LOGOUT:
			return bookingInit
		default:
			return state
	}
}

export default booking



// WEBPACK FOOTER //
// ./src/reducers/data/booking.js